import { useStatsigLayer } from '@/hooks';
import { useMyParcelsContext } from '@/modules/pmt/context';
import { LOGGED_IN_ES_BANNER_IMAGE } from '../constants';

export const useLoggedInESBannerCopy = () => {
  const { notificationTranslation } = useMyParcelsContext();
  const { get, isReady, groupName } = useStatsigLayer('track_my_parcel_signed_in_layer');

  const { loggedInEsMainText, loggedInEsHasParcelsButtonText } = notificationTranslation;

  const fallback = {
    description: loggedInEsMainText ?? '',
    cta: loggedInEsHasParcelsButtonText ?? '',
    imageUrl: LOGGED_IN_ES_BANNER_IMAGE,
    groupName,
  };

  if (!isReady) return fallback;

  return {
    description: get('ems_banner_description', fallback.description),
    cta: get('ems_banner_cta', fallback.cta),
    // Empty by default so the bundled image stays in place when the experiment does not set it
    imageUrl: get('ems_banner_image_url', '').trim() || fallback.imageUrl,
    groupName,
  };
};
